export default "__VITE_ASSET__AgFYSAfM__"